import { StrictMode } from 'react';

import { createRouter, RouterProvider } from '@tanstack/react-router';
import { Amplify } from 'aws-amplify';
import ReactDOM from 'react-dom/client';

import { amplifyConfig } from '@aws/config/index.ts';

import * as TanStackQueryProvider from './integrations/tanstack-query/root-provider.tsx';
// Import the generated route tree
import { routeTree } from './routeTree.gen';

// Completes Hosted UI sign-ins on /redirecting; inert without an OAuth domain.
import 'aws-amplify/auth/enable-oauth-listener';
import './styles.css';

Amplify.configure(amplifyConfig);

// Create a new router instance

const { queryClient } = TanStackQueryProvider.getContext();
const router = createRouter({
  routeTree,
  context: {
    queryClient,
    auth: {
      isAuthenticated: false,
    },
  },
  defaultPreload: false,
  defaultStructuralSharing: true,
  defaultPreloadStaleTime: 0,
});

// Register the router instance for type safety
declare module '@tanstack/react-router' {
  interface Register {
    router: typeof router;
  }
}

// Render the app
const rootElement = document.getElementById('app');
if (rootElement && !rootElement.innerHTML) {
  const root = ReactDOM.createRoot(rootElement);
  root.render(
    <StrictMode>
      <TanStackQueryProvider.Provider queryClient={queryClient}>
        <RouterProvider router={router} />
      </TanStackQueryProvider.Provider>
    </StrictMode>,
  );
}
